
(function roleModifyControllerDefinition() {
    'use strict';

    angular.module('Role')
        .controller('RoleModifyController', [
            '$scope', 'config', '$state', '$translate', '$stateParams', 'errorsExtend', 'adminRoleService', 'authExtend',
            function roleModifyController($scope, config, $state, $translate, $stateParams, errors, adminRoleService, authExtend) {
                $scope.title = 'RoleModify';

                $scope.requiredOu = authExtend.getOrganizationId() ? true : false;

                adminRoleService.getById($stateParams.id).then(function (result) {
                    $scope.role = result;
                }, function (error) {
                    errors.showError(error);
                    $state.go('role-find');
                });

                $scope.cancel = function () {
                    $state.go('role-find');
                };

                $scope.save = function () {
                    if (!$scope.roleForm.$valid) {
                        errors.showError('VerifyFormData');
                        $scope.roleForm.$setSubmitted();
                        return false;
                    }

                    return adminRoleService.modify($scope.role).then(function () {
                        $state.go('role-functions', { id: $scope.role.id });
                    },
                        function (error) {
                            errors.showError(error);
                        });
                };
            }
        ]);
})();